/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Denied_BodyInputs */

const en_adm_denied_body = /** @type {(inputs: Adm_Denied_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration is for owners and people with admin permissions. Ask an owner of this instance to give you access.`)
};

const de_adm_denied_body = /** @type {(inputs: Adm_Denied_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Administration ist für Eigentümer und Personen mit Admin-Rechten. Bitte einen Eigentümer dieser Instanz, dir Zugriff zu geben.`)
};

/**
* | output |
* | --- |
* | "Administration is for owners and people with admin permissions. Ask an owner of this instance to give you access." |
*
* @param {Adm_Denied_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_denied_body = /** @type {((inputs?: Adm_Denied_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Denied_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_denied_body(inputs)
	return en_adm_denied_body(inputs)
});